export const isWgsOrWes = (datasetVersionId) => (process.env.WES_DATASET_VERSION_ID === datasetVersionId
    || process.env.WGS_DATASET_VERSION_ID === datasetVersionId);
